import getMyOutlookViewState from "../store/myOutlookViewState";

export function isMyOutlookFullPageShowing(): boolean {
    return getMyOutlookViewState().isFullPageShowing;
}

export function shouldShowMyOutlookReadingPane(isFullPageShowing: boolean, isProductEnabled: boolean, isSearchTableShown: boolean, isMultipleSelection: boolean, isComposeOrSecondaryReadingPaneTab: boolean): boolean {
    return (isFullPageShowing &&
        isProductEnabled &&
        !isSearchTableShown &&
        !isMultipleSelection &&
        !isComposeOrSecondaryReadingPaneTab);
}
